import { PayloadAction } from '@reduxjs/toolkit';

import { AppState } from 'editor/src/store/app/types';

const setSelectedTechForAreaReducer = (
  state: AppState,
  { payload }: PayloadAction<{ canonicalName: string; technology: string }>,
) => {
  if (!state.selectedTechByArea) {
    state.selectedTechByArea = {};
  }
  state.selectedTechByArea[payload.canonicalName] = payload.technology;
};

export default setSelectedTechForAreaReducer;
